import { useEffect } from 'react';
import Drawer from '@mui/material/Drawer';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import TextsmsOutlinedIcon from '@mui/icons-material/TextsmsOutlined';
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined';
import PriceChangeOutlinedIcon from '@mui/icons-material/PriceChangeOutlined';
import AddchartIcon from '@mui/icons-material/Addchart';
import AnalyticsOutlinedIcon from '@mui/icons-material/AnalyticsOutlined';
import AccountBalanceWalletOutlinedIcon from '@mui/icons-material/AccountBalanceWalletOutlined';
import PsychologyAltIcon from '@mui/icons-material/PsychologyAlt';
import SwapVertIcon from '@mui/icons-material/SwapVert';

import Theme from '../../../layout/Theme';
import FeedbackModal from './FeedbackModal';
import FinishModal from './FinishModal';
import HamburgerSVG from './HamburgerSVG';
import ReportModal from './ReportModal';
import SupportModal from './SupportModal';
import { ROUTES } from '../../../constants/routes';
import Button from '../../../components/Button';

const MenuSideBar = ({
  isDarkMode,
  isMenuSideBarOpen,
  setIsMenuSideBarOpen,
  selectedModal,
  setSelectedModal,
  isSubmitReportFormLoading,
  reportFormik,
  handleCloseReportModal,
  isSubmitFeedbackFormLoading,
  feedbackFormik,
  handleCloseFeedbackModal,
  isSubmitSupportFormLoading,
  supportFormik,
  handleCloseSupportModal,
  saveMessage,
  handleCloseFinishModal,
  submitMessage,
  isLogin,
}) => {
  useEffect(() => {
    const target = window.location.hash.replace('#', '');
    switch (target) {
      case 'baoloidulieu':
        onOpenSideBarModal('report');
        break;
      case 'gopy':
        onOpenSideBarModal('feedback');
        break;
      case 'hotro':
        onOpenSideBarModal('support');
        break;
      default:
        break;
    }
  }, []);

  const onOpenSideBarModal = (typeModal) => {
    setSelectedModal(typeModal);
    setIsMenuSideBarOpen(false);
  };

  const onCloseSideBarModal = (event, reason, typeModal) => {
    if (reason == 'backdropClick') {
      event.stopPropagation();
    } else {
      switch (typeModal) {
        case 'report':
          handleCloseReportModal();
          break;
        case 'feedback':
          handleCloseFeedbackModal();
          break;
        case 'support':
          handleCloseSupportModal();
          break;
        case 'finish':
          handleCloseFinishModal();
          break;
      }
    }
  };

  return (
    <Theme>
      <Drawer
        anchor={'left'}
        open={isMenuSideBarOpen}
        onClose={() => setIsMenuSideBarOpen(!isMenuSideBarOpen)}
      >
        <div className="flex flex-col justify-between h-full menu-sidebar">
          <aside className="flex-shrink-0 relative z-20 menu-content">
            <div className="flex items-center w-full pt-[22px] pl-[18px] text-black dark:text-white">
              <button
                className="p-1 text-xs mr-1 md:mr-4 -ml-1 rounded-md focus:outline-none focus:shadow-outline-purple"
                onClick={() => setIsMenuSideBarOpen(false)}
              >
                <HamburgerSVG />
              </button>
              <a className="no-underline" href={ROUTES.homePage}>
                <img
                  src={
                    !isDarkMode
                      ? '/images/a369/logo.svg'
                      : '/images/a369/logo-dark.svg'
                  }
                  alt="Stockup.vn - Trợ lý đầu tư chứng khoán."
                  width="50px"
                />
              </a>
            </div>
            <div className="py-4 text-gray-500 dark:text-gray-400">
              <ul className="mt-0">
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href="/"
                  >
                    <span>
                      <PsychologyAltIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Hỏi StockUp AI</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href="/chung-khoan"
                  >
                    <span>
                      <AnalyticsOutlinedIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Thị trường hôm nay</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.highLightByStockup}
                  >
                    <span>
                      <PriceChangeOutlinedIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Lọc cổ phiếu</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.newsStockMarket}
                  >
                    <span>
                      <NewspaperOutlinedIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Tin thị trường chứng khoán</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.derivativeVN30}
                  >
                    <span>
                      <SwapVertIcon className="text-xl" />
                    </span>
                    <span className="ml-5">
                      Công cụ phân tích chứng khoán phái sinh
                    </span>
                  </a>
                </li>
                {/* <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.stockAnalysis}
                  >
                    <span>
                      <ImportantDevicesIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Phân tích cổ phiếu miễn phí</span>
                  </a>
                </li> */}
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.followCompany}
                  >
                    <span>
                      <AddchartIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Danh mục theo dõi</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <a
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100"
                    href={ROUTES.manageInvestments}
                  >
                    <span>
                      <AccountBalanceWalletOutlinedIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Danh mục đầu tư</span>
                  </a>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <button
                    onClick={() => onOpenSideBarModal('report')}
                    type="button"
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100 cursor-pointer"
                  >
                    <span>
                      <WarningAmberIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Báo lỗi dữ liệu</span>
                  </button>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <button
                    onClick={() => onOpenSideBarModal('feedback')}
                    type="button"
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100 cursor-pointer"
                  >
                    <span>
                      <TextsmsOutlinedIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Góp ý</span>
                  </button>
                </li>
                <li className="relative pr-4 py-3 pl-5">
                  <button
                    onClick={() => onOpenSideBarModal('support')}
                    type="button"
                    className="inline-flex items-center w-full text-sm font-semibold transition-colors duration-200 hover:text-primary-main dark:hover:text-primary-main text-black dark:text-gray-100 cursor-pointer"
                  >
                    <span>
                      <HelpOutlineIcon className="text-xl" />
                    </span>
                    <span className="ml-5">Hỗ trợ</span>
                  </button>
                </li>
                {!isLogin ? (
                  <>
                    <li className="sm:hidden relative pr-4 py-3 pl-5">
                      <Button
                        href={ROUTES.login}
                        className="w-full btn-login-sidebar"
                      >
                        <span className="mr-1">
                          <i className="ri-login-box-line text-xl font-normal "></i>
                        </span>
                        Đăng nhập
                      </Button>
                    </li>
                    <li className="sm:hidden relative pr-4 py-3 pl-5">
                      <Button
                        href={ROUTES.signup}
                        className="w-full btn-register-sidebar"
                      >
                        <span className="mr-1">
                          <i className="ri-file-user-line text-xl font-normal "></i>
                        </span>
                        Đăng ký
                      </Button>
                    </li>
                  </>
                ) : null}
              </ul>
            </div>
          </aside>
          <div className="text-sm text-black dark:text-gray-100 font-normal text-center pb-4 mt-6 px-3">
            Phát triển và quản lý bởi
            <a
              href={ROUTES.appPage}
              target="_blank"
              className="font-bold text-primary-main no-underline hover:underline dark:text-primary-light transition ease-in-out duration-200 ml-1"
              title="Stockup.vn - Trợ lý đầu tư chứng khoán."
            >
              Stockup
            </a>
          </div>
        </div>
      </Drawer>
      <ReportModal
        isOpen={selectedModal == 'report'}
        onCloseModal={(event, reason) => {
          onCloseSideBarModal(event, reason, 'report');
        }}
        isLoading={isSubmitReportFormLoading}
        formik={reportFormik}
        saveMessage={saveMessage}
      />
      <FeedbackModal
        isOpen={selectedModal == 'feedback'}
        onCloseModal={(event, reason) => {
          onCloseSideBarModal(event, reason, 'feedback');
        }}
        isLoading={isSubmitFeedbackFormLoading}
        formik={feedbackFormik}
        saveMessage={saveMessage}
      />
      <SupportModal
        isOpen={selectedModal == 'support'}
        onCloseModal={(event, reason) => {
          onCloseSideBarModal(event, reason, 'support');
        }}
        isLoading={isSubmitSupportFormLoading}
        formik={supportFormik}
        saveMessage={saveMessage}
      />
      <FinishModal
        isOpen={selectedModal == 'finish'}
        onCloseModal={(event, reason) => {
          onCloseSideBarModal(event, reason, 'finish');
        }}
        submitMessage={submitMessage}
      />
    </Theme>
  );
};

export default MenuSideBar;
